<template>
  <div class="house">
    <div
      class="rightmouse"
      :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px', opacity: rightMouseFlag ? '1' : '0' }"
    >
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <el-breadcrumb-item>媒资检索</el-breadcrumb-item>
          <el-breadcrumb-item>图集浏览</el-breadcrumb-item>
          <el-breadcrumb-item>{{ atlasInfo.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main" v-loading="isRefresh">
      <!-- <div v-if="isUpload" class="head disflex">
        <div class="left">
          <p>{{$route.params.name}} / 共<span>654</span>张 </p>
        </div>
        <div class="right disflex">
          <p>创建时间：{{'2020-4-5'}}</p>
          <p>创建人：{{'云图管理员'}}</p>
          <el-button @click="openUpload"><i class="el-icon-plus"></i> 补充图片</el-button>
        </div>
      </div>-->

      <div class="uploadhead disflex">
        <div class="name">
          <h4>{{ atlasInfo.name }}</h4>
          <div class="choose">
            <div @click="chooseType(0)" :class="chooseFlag == 0 ? 'active' : ''" class="chobj">
              <img src="@/assets/piclist/pic.png" alt />
              {{ atlasInfo.pictureCount || 0 }}
            </div>
            <div @click="chooseType(1)" :class="chooseFlag == 1 ? 'active' : ''" class="chobj">
              <img src="@/assets/piclist/video.png" alt />
              {{ atlasInfo.videoCount || 0 }}
            </div>
            <div @click="chooseType(2)" :class="chooseFlag == 2 ? 'active' : ''" class="chobj">
              <img src="@/assets/piclist/wordicon.png" alt />
              {{ atlasInfo.documentCount || 0 }}
            </div>


            <div
              style="margin-left: 30px"
              v-if="chooseFlag == 0 || chooseFlag == -1"
            >
              <img
                @click="isTable = false"
                :src="
                  !isTable
                    ? isCustom
                      ? custom == 'xugong'
                        ? require('@/assets/custom/xg-p-h.png')
                        : require('@/assets/custom/wc-p-h.png')
                      : require('@/assets/custom/m-p-h.png')
                    : isCustom
                    ? custom == 'xugong'
                      ? require('@/assets/custom/xg-p.png')
                      : require('@/assets/custom/wc-p.png')
                    : require('@/assets/custom/m-p.png')
                "
                style="margin-right: 10px;cursor: pointer;"
                alt=""
              />
              <img
                @click="isTable = true"
                style="cursor: pointer;"
                :src="
                  isTable
                    ? isCustom
                      ? custom == 'xugong'
                        ? require('@/assets/custom/xg-table-h.png')
                        : require('@/assets/custom/wc-table-h.png')
                      : require('@/assets/custom/m-table-h.png')
                    : isCustom
                    ? custom == 'xugong'
                      ? require('@/assets/custom/xg-table.png')
                      : require('@/assets/custom/wc-table.png')
                    : require('@/assets/custom/m-table.png')
                "
                alt=""
              />
            </div>
          </div>
        </div>

        <div v-if="!isRemove">
          <el-button v-if="powersObj.manageAtlas" @click="deleteAtlas">删除图集</el-button>
          <el-button v-if="powersObj.manageAtlas" @click="unFormatAtlasClick">取消归档</el-button>
          <el-button
            v-if="powersObj.manageAtlas"
            @click="supplyPic"
            :style="{ 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
            class="btn"
          >
            <i class="el-icon-plus"></i> 补充资源
          </el-button>
          <el-button v-if="powersObj.manageAtlas"
                      @click="batch"
                      :style="{ 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3', 'color': '#fff', 'borderRadius': '5px' }">
              <i class="el-icon-rank"></i> 批量操作
            </el-button>
          <el-button @click="$router.push('/pictureCenter')">返回</el-button>
        </div>

        <div v-else>
            <el-button @click="addplLabel"
                       v-if="powersObj.allowOperationCustomLabel"
                      :style="{ 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3', 'color': '#fff', 'borderRadius': '5px' }">
              新增手动标签
            </el-button>
            <el-button @click="allDel"
                      v-if="isHasVideo"
                      :style="{ 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3', 'color': '#fff', 'borderRadius': '5px' }">
              删除
            </el-button>
            <el-button @click="allChoose">{{chooseText}}</el-button>
            <el-button @click="closeremove">取消</el-button>

        </div>
      </div>
      <seePeopleFace @clickFaceDialogHandleClose="clickFaceDialogHandleClose" ref="seePeopleFace"></seePeopleFace>
      <div class="piclist">
        <div v-if="!isTable" style="width:calc(100% - 450px);min-height:805px;">
          <template v-if="picFlag">
            <section>
              <div
                @click="!isRemove && picList[0].src !== require('@/assets/house/grey.png') && openDialog(index, item)"
                class="img-wrapper"
                v-for="(item, index) in picList"
                :key="index"
                :style="{flexGrow:item.type === 'word' ? '0' : '1'}"
              >
                <img class="circle"
                     v-if="batchList.indexOf(item.id) !== -1 && isRemove"
                     src="@/assets/personpic/gou.png" />
                <el-image
                  class="img"
                  :style="{width:item.picW?item.picW*150/item.picH+'px' : '100'+'px'}"
                  v-if="item.type == 'pic' && !isRemove"
                  @contextmenu.prevent="rightShow($event)"
                  ondragstart="return false;"
                  fit="cover"
                  :src="item.src"
                >
                  <div slot="error" class="image-slot">
                    <img src="@/assets/house/onloadpicerror.png" alt />
                  </div>
                </el-image>
                <el-image
                  class="img"
                  :style="{width:item.picW?item.picW*150/item.picH+'px' : '100'+'px'}"
                  v-if="item.type == 'pic' && isRemove"
                  @contextmenu.prevent="rightShow($event)"
                  @click.stop="choosePic(item)"
                  ondragstart="return false;"
                  fit="cover"
                  :src="item.src"
                >
                  <div slot="error" class="image-slot">
                    <img src="@/assets/house/onloadpicerror.png" alt />
                  </div>
                </el-image>

                <video style="height:150px;" @click="isRemove && choosePic(item)" v-if="item.type === 'video'" :src="item.src"></video>

                <div  v-if="item.type === 'word'"
                      class="word"
                      >
                  <img src="@/assets/piclist/wordlist.png" alt="">
                  <h3>{{item.title}}</h3>
                  <p>{{item.content}}</p>
                  <div class="read" @click.stop="openWord(item)">
                    <div>阅读详情</div>
                    <img src="@/assets/piclist/you.png" style="margin-left:6px;" alt="">
                  </div>
                </div>

                <!-- 下载图片信息 -->
                <div v-if="item.type == 'pic'" class="download">
                    <img src="@/assets/piclist/downloadout.png"
                        alt />
                    <p>{{item.downloadCount}}</p>
                </div>

                <div class="dian" v-if="!isRemove">
                  <img src="@/assets/piclist/dian.png" alt="">
                  <div class="diannr">
                    <p v-if="item.type == 'pic'" @click.stop="removePic(item)">移出图片</p>
                  <p v-if="item.type == 'pic'" @click.stop="deletePic(item)">删除图片</p>
                  <p v-if="item.type == 'pic'" @click.stop="downloadimg(item)">下载图片</p>
                    <p v-if="item.type == 'pic' && powersObj.selectPicture" @click.stop="lovePicOut(index, item)">
                      {{loveList.indexOf(item.id) === -1 ? '选用图片' : '移除图片'}}
                    </p>
                    <p v-if="powersObj.manageAtlas && item.type == 'pic'" @click.stop="openChangeDesc(item)">修改图片说明</p>
                    <p v-if="item.type == 'video'" @click.stop="download(item)">下载视频</p>
                    <p v-if="item.type == 'video' && powersObj.manageAtlas" @click.stop="deleteVideo(item)">删除视频</p>
                    <p v-if="item.type == 'video' && powersObj.manageAtlas" @click.stop="openChangeDescvideo(item)">修改视频说明</p>
                    <p v-if="item.type == 'word'" @click.stop="openWord(item)">预览文稿</p>
                    <p v-if="item.type == 'word'" @click.stop="delWord(item)">删除文稿</p>
                    <p v-if="item.type == 'word' && !item.isUpload" @click.stop="downloadWord(item)">下载文稿</p>
                    <p v-if="item.type == 'word' && !item.isUpload && powersObj.documentCompile" @click.stop="changeWord(item)">编辑文稿</p>
                    
                  </div>
                </div>

                <!-- 修改图片信息 -->
                <!-- <el-tooltip class="item" effect="dark" content="修改图片说明" placement="top">
                  <div
                    @click.stop="openChangeDesc(item)"
                    class="changedesc"
                    v-if="item.type == 'pic' && powersObj.manageAtlas"
                  >
                    <img src="@/assets/sreenpic/desc.png" alt />
                  </div>
                </el-tooltip> -->

                <!-- 修改视频信息 -->
                <!-- <el-tooltip class="item" effect="dark" content="修改视频说明" placement="top">
                  <div
                    @click.stop="openChangeDesc(item)"
                    class="changedesc"
                    v-if="item.type == 'video' && powersObj.manageAtlas"
                  >
                    <img src="@/assets/sreenpic/desc.png" alt />
                  </div>
                </el-tooltip> -->

                <!-- 下载视频 -->
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="下载视频"
                            placement="top">
                  <div @click.stop="download(item)"
                      v-if="item.type == 'video'"
                      class="downvideo">
                    <img src="@/assets/personpic/down.png"
                        alt />
                  </div>
                </el-tooltip> -->

                <!-- <el-tooltip class="item" effect="dark" content="选用图片" placement="top">
                  <div
                    @click.stop="lovePicOut(index, item)"
                    v-if="item.type == 'pic' && powersObj.selectPicture"
                    class="love"
                  >
                    <img
                      v-if="loveList.indexOf(item.id) === -1"
                      src="@/assets/piclist/love.png"
                      alt
                    />
                    <img v-if="loveList.indexOf(item.id) > -1" src="@/assets/piclist/lovec.png" alt />
                  </div>
                </el-tooltip> -->

                <!-- 播放 -->
                <div v-if="item.type == 'video'" class="play">
                  <img src="@/assets/piclist/playb.png" alt />
                </div>
              </div>
            </section>
          </template>
          <template v-if="!picFlag">
            <div class="nopic">
              <img src="@/assets/piclist/nonr.png" alt />
            </div>
          </template>
          <img
            v-if="showLoading"
            class="myloading"
            width="200px"
            src="@/assets/blue-preloader.gif"
            alt
          />
        </div>

        <template v-if="isTable">
          <div class="pictable">
            <el-table
              :data="picTableData"
              :border="false"
              stripe
              style="width: 100%"
              @sort-change="changeTableSort"
            >
              <el-table-column prop="desc" label="名称">
                <template slot-scope="scope">
                  <div style="display: flex; flex-align: center">
                    <img
                      style="margin-right: 6px;cursor: pointer;"
                      :src="scope.row.picThumbWh160"
                      width="20"
                      height="20"
                      @click="openDialog(scope.$index, scope.row)"
                      alt=""
                    />
                    <span>{{ scope.row.desc }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="customArr" label="标签">
                <template slot-scope="scope">
                  <div style="display: flex; flex-align: center;flex-wrap:wrap;">
                    <template v-if="scope.row.customArr == '——'">
                      <span>{{ scope.row.customArr }}</span>
                    </template>
                    <template v-else>
                      <div v-for="(e, i) in scope.row.customArr" :key="i">
                        <el-tag style="margin-right: 4px;margin-bottom: 4px;">{{ e }}</el-tag>
                      </div>
                    </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="fileSize" label="大小" :sortable="'custom'"> </el-table-column>
              <el-table-column prop="ext" width="80" label="种类"> </el-table-column>
              <el-table-column prop="size" label="尺寸"> </el-table-column>
              <el-table-column prop="createName" width="120" label="上传人">
              </el-table-column>
              <el-table-column prop="createAtUp" label="上传时间" :sortable="'custom'">
              </el-table-column>
              <el-table-column prop="createAtp" label="拍摄时间">
              </el-table-column>
            </el-table>

            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
              </el-pagination>
            </div>
          </div>
        </template>

        <!-- <div v-if="!isUpload" class="picdescribe">
          <p>图片描述：</p>
          <el-input class="describeinput" v-model="picDescribe" placeholder="内容文字不超过200字"></el-input>
        </div>-->

        <div v-if="!isTable" :class="picinfClass">
          <div class="curtain disflex">
            <h4>图集信息</h4>
            <div>
              <div class="disflex">
                <img src="@/assets/piclist/see.png" alt />
                <p>浏览量</p>
              </div>

              <p>{{ atlasInfo.viewCount }}</p>
            </div>
          </div>

          <div class="nr">
            <p>
              <span>图片数:</span>
              {{ atlasInfo.pictureCount }}张
            </p>
            <p>
              <span>视频数:</span>
              {{ atlasInfo.videoCount }}个
            </p>
            <p>
              <span>文稿数:</span>
              {{ atlasInfo.documentCount }}个
            </p>
            <p>
              <span>图库名:</span>
              {{ atlasInfo.libName }}
            </p>
            <p>
              <span>创建人:</span>
              {{ createUserInfo.name }}
            </p>
            <p>
              <span>创建人手机:</span>
              {{ createUserInfo.mobile }}
            </p>
            <p>
              <span>创建时间:</span>
              {{ atlasInfo.createAtMY }}
            </p>
            <hr />
            <br />
            <br />
            <p style="display:flex;align-items: center;justify-content:space-between">
              <span>图集说明:</span>
              <span
                v-if="createUid == atlasInfo.createUserInfoId"
                @click="openAtlasDesc"
                class="change"
              >
                <img src="@/assets/sreenpic/desc.png" alt />
              </span>
            </p>
            <p style="line-height:32px;">{{ atlasInfo.desc || '暂无' }}</p>
            <hr />
            <br />
            <br />
            <p>
              <span>图集动态:</span>
            </p>
            <div class="tjdt">
              <el-timeline v-if="activities.length > 0" :reverse="reverse">
                <el-timeline-item v-for="(activity, index) in activities" :key="index">
                  <div style="color:#666666;font-size:14px;">
                    {{ activity.timestamp }}
                    <span style="margin-left:25px;">{{ activity.content }}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
              <span style="font-size:14px;" v-if="activities.length == 0">暂无</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="atlasDialogVisible" width="30%" append-to-body :show-close="false">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>修改图集说明</div>
      </div>
      <div class="bj">
        <div style="width:100px;position: relative;top:-50px;">图集说明：</div>
        <el-input
          placeholder="请输入图集说明"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 8 }"
          v-model="atlasInfodesc"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAtlas">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="changeAtlasDesc"
        >确 定</el-button>
      </span>
    </el-dialog>

    <addLabel
      :dialogVisible="addLabelFlag"
      @handleClose="labelhandleClose"
      @changeDesc="changeLabel"
    ></addLabel>

    <changedescdialog
      :message.sync="message"
      :dialogVisible="descdialogVisible"
       ref="openChangeDescs"
      @handleClose="deschandleClose"
      @changeDesc="changeDesc"
    ></changedescdialog>
    <!-- 图片点击弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      top="12vh"
      class="seepic"
      :show-close="false"
    >
      <!-- 关闭按钮 -->
      <div @click="dialogVisible = false" class="close">
        <img
          :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
          src="@/assets/picbrowse/close.png"
          alt
        />
      </div>

      <div class="left">
        <div
          class="pic"
          v-loading="imgLoading"
          element-loading-text="正在加载图片中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <!-- <el-switch style="position:absolute;top:20px;right:20px;"
                     v-model="switechValue">
          </el-switch>-->
          <!-- <el-switch style="position:absolute;top:20px;right:20px;"
                     v-model="switechValue"
                     @change="clearLargeAndSmall">
          </el-switch>-->
          <div class="imgBj" ref="imgBj">
            <!-- <img ref="imgPic"
                 height="78%"
                 v-drag
                 v-lazy="choosePicMsg.src"
            v-if="!switechValue">-->
            <div
              ref="imgPic"
              @contextmenu.prevent="rightShow($event)"
              ondragstart="return false;"
              v-if="choosePicMsg.type == 'pic'"
              @click="seeBigSmall"
              :style="{ cursor: seeFull ? 'zoom-out' : 'zoom-in',height: '98%', width: '100%', backgroundImage: 'url(' + choosePicMsg.src + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"
            ></div>

            <!-- <img
              ref="imgPic"
              @contextmenu.prevent="rightShow($event)"
              ondragstart="return false;"
              height="98%"
              v-if="choosePicMsg.type == 'pic'"
              :style="seeFull ? 'cursor:zoom-out' : 'cursor:zoom-in'"
              v-lazy="choosePicMsg.src"
              @click="seeBigSmall"
            /> -->

            <video-player
              v-else
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              style="width:70%;height:100%;"
              :playsinline="true"
              :options="playerOptions"
            ></video-player>

            <div v-if="choosePicMsg.type == 'pic' && switechValue" class="origin">
              <div
                ref="picface"
                class="faceBorder"
                :style="'position: absolute;display:flex;justify-content:center;align-items:center;border:1px dashed #00ccff;;height:' +
                item.height + 'px;width:' +
                item.width + 'px;top:' +
                item.top + 'px;left:'
                + item.left + 'px;'"
                v-for="(item,index) in choosePicMsg.faceInfo"
                :key="index"
              >
                <div style="width:93%;height:93%;border:1px dotted #666;">
                  <div
                    class="yuan"
                    :style="{ 'left': (item.width - 20) + 'px', 'top': (item.height / 2) + 'px' }"
                  ></div>
                  <div
                    class="faceName"
                    :title="item.peopleName"
                    @click="powersObj.myFace && !seeFull && getFaceId(1, item, index)"
                    :style="{ 'left': (item.width - 10) + 'px', 'top': (item.height / 2 - 10) + 'px' }"
                  >{{ item.peopleName.length > 11 ? item.peopleName.substring(0, 11) + '…' : item.peopleName }}</div>
                </div>
              </div>
            </div>

            <div @click="bigLeft" class="leftjt">
              <div class="message" v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight" class="rightjt">
              <div class="message" v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i
              @click="picRotateRight"
              v-if="seeFull"
              class="el-icon-refresh-right"
              style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"
            ></i>
            <i
              @click="picRotateLeft"
              v-if="seeFull"
              class="el-icon-refresh-left"
              style="position:absolute; bottom:20px;font-size: 30px;"
            ></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn"
               v-if="!switechValue">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div>-->
        </div>

        <div class="picinf disflex">
          <p class="picinfleft">
            <span :title="atlasInfo.name">{{ atlasInfo.name.length > 20 ? atlasInfo.name.substring(0, 20) + '…' : atlasInfo.name  }}</span> / 共
            <span>{{ atlasInfo.pictureCount }}</span>张图片和<span>{{atlasInfo.videoCount}}</span>个视频
          </p>
          <div class="picinfright disflex" v-if="choosePicMsg.type == 'pic' && choosePicMsg.errortext !== 'error'">
            <div class="disflex" style="cursor:default;">
              <img src="@/assets/piclist/downloadin.png" alt="">
              <p style="marginRight:5px;">下载次数</p>
              <p>{{choosePicMsg.downloadCount}}</p>
            </div>
            <div
              @click.stop="seeFace"
              v-if="!isSimple"
              class="disflex face"
              :style="{ background: !switechValue ? 'url(' + require('@/assets/picbrowse/face.png') + ') no-repeat' : 'url(' + require('@/assets/picbrowse/facehover.png') + ') no-repeat' }"
            >
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/spare.png" alt=""> -->
              <p :style="{ color: switechValue ? '#6ea4ff' : '#FFFFFF' }">人脸({{ faceLength }})</p>
            </div>
            <div
              v-if="powersObj.selectPicture"
              @click.stop="lovePic"
              class="disflex spare"
              :style="{ background: !haslovechange ? 'url(' + require('@/assets/picbrowse/spare.png') + ') no-repeat' : 'url(' + require('@/assets/picbrowse/sparelove.png') + ') no-repeat' }"
            >
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/spare.png" alt=""> -->
              <p>选用</p>
            </div>
            <div v-if="powersObj.manageAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/book.png" alt=""> -->
              <p>设为封面</p>
            </div>
            <div v-if="powersObj.manageAtlas"
                 @click="removePic"
                 class="disflex remove">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>移出</p>
            </div>
            <div v-if="powersObj.manageAtlas" @click="deletePic" class="disflex delete">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>删除</p>
            </div>
            <!-- <div @click.stop="dev" class="disflex download">
            <div class="icon"></div>
            <p>下载原图 <span style="font-size:12px;"> (已下载{{choosePicMsg.downloadCount}}次)</span> </p>
            </div>-->
          </div>

          <div class="picinfright disflex"
               v-if="choosePicMsg.type == 'video'">
            <div @click.stop="download(choosePicMsg)" class="disflex download">
              <div class="icon"></div>
              <p>下载</p>
            </div>
            <div v-if="powersObj.createAtlas"
                 @click="deleteVideo"
                 class="disflex delete">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>删除</p>
            </div>
          </div>
        </div>

        <div ref="piclist" class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1" @click="smallLeft" class="leftjt">
            <i style="font-size:30px;" class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist" style="display:flex;transition:1s;">
            <div @click="picListClick(e, i)" v-for="(e,i) in picList" :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div
                :style="{ backgroundImage: 'url(' + e.picThumbWh160 + ')', cursor: 'pointer' }"
                @contextmenu.prevent="rightShow($event)"
                ondragstart="return false;"
                :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active' : 'picimg'"
              ></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13" @click="smallRight" class="rightjt">
            <i style="font-size:30px;" class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div v-if="choosePicMsg.type == 'pic'" class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <!-- <p><div class="key">用户名</div><div class="value">可爱无敌美少女</div></p> -->
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{ picExif.CreateAtMy || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{ picInfo.createAt || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">所属图库</div>：
          <span>{{ atlasInfo.libName || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{ picExif.Make || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ picInfo.picW }}*{{ picInfo.picH }}像素</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>：
          <span>{{ picInfo.fileSize }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">作者</div>：
          <span>{{ dataimgzuozhe||'暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{ picInfo.format }}</span>
        </div>
        <div
          v-if="picExif.ExposureTime"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">曝光时间</div>：
          <span>{{ picExif.ExposureTime }}秒</span>
        </div>
        <div
          v-if="!picExif.ExposureTime"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">曝光时间</div>：
          <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{ picExif.ISOSpeedRatings || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{ picExif.FocalLength || '暂无' }}</span>
        </div>

        <div style="margin-top:25px;" class="title" v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{ choosePicMsg.desc }}</p>

        <div
          style="margin-top:25px;"
          class="title"
          v-if="choosePicMsg.labels.length > 0 && !isSimple"
        >
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div
          v-if="!isSimple"
          style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;"
        >
          <div
            style="margin-left:5px;margin-bottom:5px;"
            v-for="(e,i) in choosePicMsg.labels"
            :key="i"
          >
            <el-tag>{{ e }}</el-tag>
          </div>
        </div>


        <div
          style="margin-top: 25px"
          class="title"
        >
          <p>手动标签</p>
        </div>

        <div
          
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 10px;
          "
        >
          <template v-if="choosePicMsg.hasOwnProperty('customLabelsArr')">
            <div
              style="margin-left: 5px; margin-bottom: 5px"
              v-for="(e, i) in choosePicMsg.customLabelsArr"
              :key="i"
            >
              <el-tag :closable="powersObj.allowOperationCustomLabel" @close="tagClose(e)" type="success">{{ e }}</el-tag>
            </div>
            <el-tag v-if="powersObj.allowOperationCustomLabel" @click="openAddLabel" style="margin-left: 5px; margin-bottom: 5px;cursor: pointer;" type="success">新建 +</el-tag>
          </template>
          <template v-else>
            <el-tag v-if="powersObj.allowOperationCustomLabel" @click="openAddLabel" style="margin-left: 5px; margin-bottom: 5px;cursor: pointer;" type="success">新建 +</el-tag>
            <div v-else>暂无</div>
          </template>
          
        </div>



        <div
          style="margin-top:25px;"
          class="title"
          v-if="choosePicMsg.faceInfo.length > 0 && !isSimple"
        >
          <p>人物</p>
          <div class="alert">仅供参考</div>
        </div>

        <div
          v-if="!isSimple"
          style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;"
        >
          <div
            style="margin-left:5px;margin-bottom:5px;cursor: pointer;"
            v-for="(e,i) in choosePicMsg.faceInfo"
            :key="i"
          >
            <el-tag
              type="success"
              @click.stop="powersObj.myFace && seepersonallface(e)"
            >{{ e.peopleName }}</el-tag>
          </div>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.logs ? choosePicMsg.logs.length > 0 : false">
          <p>下载用户</p>
        </div>

        <div v-if="choosePicMsg.logs.length > 0"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;width:100%;"
               class="disflex"
               v-for="(e,i) in choosePicMsg.logs"
               :key="i">
            <p>{{e.createName}}</p>
            <p>{{e.createAtMY}}</p>
          </div>
        </div>

        <div class="msg disflex" v-if="false">
          <div class="picmsg">
            <p>{{ choosePicMsg.shareCount }}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png" alt />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.pushCount }}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png" alt />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.downloadCount }}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png" alt />
          </div>
        </div>
      </div>

      <div v-else class="right">
        <div class="title">
          <p>视频信息</p>
        </div>
        <!-- <p><div class="key">用户名</div><div class="value">可爱无敌美少女</div></p> -->
        <!-- <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{ picExif.CreateAtMy || '无' }}</span>
        </div> -->
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{ picInfo.createAt || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">所属图库</div>：
          <span>{{ atlasInfo.libInfo.name || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频大小</div>：
          <span>{{ picInfo.fileSize }}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频格式</div>：
          <span>{{ picInfo.format }}</span>
        </div>
    <div v-if="typeof datavideozuozhe.CreateAt != 'number' " style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{ datavideozuozhe.CreateAt ? moment(datavideozuozhe.CreateAt).format('YYYY-MM-DD') :'暂无' }}</span>
        </div>
        <div  v-if="typeof datavideozuozhe.CreateAt == 'number' " style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span v-if="datavideozuozhe.CreateAt<9999999999">{{ datavideozuozhe.CreateAt ? moment.unix(datavideozuozhe.CreateAt).format('YYYY-MM-DD'):'暂无' }}</span>
          <span v-if="datavideozuozhe.CreateAt>9999999999">{{ datavideozuozhe.CreateAt ? moment.unix(datavideozuozhe.CreateAt/1000).format('YYYY-MM-DD'):'暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄地点</div>：
          <span>{{ datavideozuozhe.videoAddress||'暂无'  }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频人物</div>：
          <span>{{ datavideozuozhe.videoCharacter||'暂无'  }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频事件</div>：
          <span>{{ datavideozuozhe.videoEvent||'暂无'  }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频分类</div>：
          <span>{{ datavideozuozhe.videoClassification||'暂无'  }}</span>
        </div>

        <div style="margin-top:25px;" class="title" v-if="choosePicMsg.desc">
          <p>视频说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{ choosePicMsg.desc }}</p>

        <div
          style="margin-top: 25px"
          class="title"
        >
          <p>手动标签</p>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 10px;
          "
        >
          <template v-if="choosePicMsg.hasOwnProperty('customLabelsArr')">
            <div
              style="margin-left: 5px; margin-bottom: 5px"
              v-for="(e, i) in choosePicMsg.customLabelsArr"
              :key="i"
            >
              <el-tag :closable="powersObj.allowOperationCustomLabel" @close="tagClose(e)" type="success">{{ e }}</el-tag>
            </div>
            <el-tag v-if="powersObj.allowOperationCustomLabel" @click="openAddLabelVideo" style="margin-left: 5px; margin-bottom: 5px;cursor: pointer;" type="success">新建 +</el-tag>
          </template>
          <template v-else>
            <el-tag v-if="powersObj.allowOperationCustomLabel" @click="openAddLabelVideo" style="margin-left: 5px; margin-bottom: 5px;cursor: pointer;" type="success">新建 +</el-tag>
            <div v-else>暂无</div>
          </template>
          
        </div>


      </div>

    </el-dialog>
    <el-dialog :visible.sync="peopleDialogVisible" width="30%" :before-close="handleClose">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>标记人物</div>
      </div>
      <el-form
        :model="faceRuleForm"
        v-loading="peopleLoading"
        :rules="faceRules"
        ref="faceRuleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="人物分类：" prop="peopleClass">
          <el-select v-model="faceRuleForm.peopleClass" style="width:100%;" placeholder="请选择人物分类">
            <el-option
              v-for="item in peopleClass"
              :key="item"
              :label="item"
              :value="item"
              v-html="'<span style=color:#303030;>' + item + '</span>'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区：" prop="region">
          <el-select v-model="faceRuleForm.region" style="width:100%;" placeholder="请选择地区">
            <el-option
              v-for="item in region"
              :key="item"
              :label="item"
              :value="item"
              v-html="'<span style=color:#303030;>' + item + '</span>'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="faceRuleForm.name" @input="myInput"></el-input>
        </el-form-item>
      </el-form>
      <div style="width:90%;margin:20px auto;" v-if="faceInputFlag">
        <p style="margin-top:30px;margin-bottom:10px;">注：如人物已存在，您可以通过输入姓名检索并合并</p>
        <el-table :data="faceData" style="width: 100%" border>
          <el-table-column prop="peopleName" label="人物姓名" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-image
                style="width:22px;height:22px;border-radius: 50%;margin-left:10px;"
                :src="scope.row.peopleLogo"
                :preview-src-list="[scope.row.peopleLogo]"
              ></el-image>
              <span>{{ scope.row.peopleName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserInfo.name" label="创建人"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <p @click="mergeFace(scope)" style="color:#185ED3;cursor: pointer;">合并</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="beSure('faceRuleForm')"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="clickFaceDialog"
      width="30%"
      :before-close="clickFaceDialogHandleClose"
    >
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>提示</div>
      </div>
      <el-radio v-model="seeOrUpdateFace" label="1">修改</el-radio>
      <el-radio v-model="seeOrUpdateFace" label="2">查看</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clickFaceDialogHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="clickFaceDialogFun"
        >确 定</el-button>
      </span>
    </el-dialog>
<el-dialog
  title="提示"
  :visible.sync="dialogVisibledefinition"
  width="30%"
  :before-close="handleClose">
  <span>请选择下载清晰度!</span>
   <el-input style="margin-top:10px" v-model="input" placeholder="请输入打包标题"></el-input>
  <p style="margin-top:20px">分辨率:
     <el-radio-group v-model="radio">
    <el-radio :label="0">高</el-radio>
    <el-radio :label="1">中</el-radio>
    <el-radio :label="2">原图</el-radio>
    <el-radio :label="3">低</el-radio>
  </el-radio-group>
  </p>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibledefinition = false">取 消</el-button>
    <el-button type="primary" @click="determine">确 定</el-button>
  </span>
</el-dialog>

    <!-- 预览文稿内容 -->
    <previewordetaildialog @handleClose='wordDialogPre = false' :dialogVisible='wordDialogPre' :message="wordPreMessage" :picList="wordPrePic"></previewordetaildialog>


    <!-- 查看文稿内容 -->
    <wordetaildialog @handleClose='wordDialog = false' :dialogVisible='wordDialog' :message="wordContent"></wordetaildialog>
      <div>
      <picviewA ref="picviewA" :picviewlist='picviewlist' />
    </div>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getDate, formatConversion } from "@/plugins/getdate";
import { picPrefix } from "@/constants/piccommon";
import {
  getAtlasInfo,
  deleteAtlas,
  unFormatAtlas,
  removePictureAtlas,
  setIndexpic,
  updateAtlas
} from "@/api/atlas";
import { setUserSetting, getUserSetting } from "@/api/config";
import { listPeopleFaceByFileId, setPeopleFaceAccess } from "@/api/peopleFace";
import { addPeople, getPeopleConstant, listPeople } from "@/api/people";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
import {
  listAtlasPictures,
  updatePicture,
  getPictures,
  getPictureLog,
  removePicturePic
} from "@/api/picture";
import {
addPicturePackage
} from "@/api/picturePackage";
import { changedescdialog,wordetaildialog,previewordetaildialog,seePeopleFace,addLabel } from '@/components/index'
import { powersObj } from "@/constants/powers";
import { addLog } from "@/api/resourceLog"
import { listAtlasVideos,updateVideo,removeVideo } from "@/api/video"
import { getFileInfoById } from "@/api/file"
import { setExtInfoapi } from "@/api/file";
import moment from "moment"
import { advSearchPicture } from "@/api/search";
import { selectList,selectInfo,deleteDocument,updateTitle } from "@/api/word";
import picviewA from '@/components/preview/index.vue'

export default {
  components: {
    changedescdialog, seePeopleFace,wordetaildialog,previewordetaildialog,addLabel,picviewA
  },
  watch: {
    '$store.state.user.isUpload'(data) {
      this.isUpload = data
    },
    '$store.state.user.loveList'(data) {
      this.loveList = data
    }
  },
  computed: {
    ...mapGetters(["createUid"]),
        
  },
  data() {
    return {
      radio:0,
      thumb:'',
      picviewlist:'',
      dialogVisibledefinition:false,
      downloadimgobj:{},
      //新增标签相关
      addLabelFlag:false,
      input:'',
      addLabelCho: 0,
      isHasVideo:false,
      plList:[],
      dataimgzuozhe:'',
      datavideozuozhe:'',
      //表格相关
      isTable: false,
      moment, 
      picTableData: [],
      //文稿相关
      wordDialogPre:false,
      wordPreMessage:'',
      wordPrePic:[],

      wordDialog:false,
      pageWord:0,
      pageSizeWord:100,
      wordContent:'',

      //视频相关
      chooseFlag: -1,
      choosedata: null,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      seeFull: false,
      showSureBtn: true,
      index: -1,
      faceInputFlag: false,
      peopleLoading: false,
      //权限
      powersObj,
      //图片选用
      loveList: [],
      atlasInfo: {},
      picPrefix,
      imgLoading: false,//图片加载
      dialogVisible: false,
      isUpload: this.$store.state.user.isUpload,
      choosePicMsg: { isLove: false, labels: [], faceInfo: [] },
      picDescribe: '',
      gallery: '',
      picname: '',
      explain: '',
      visibility: '公开',
      picFlag: true,
      picList: [

      ],
      picAllListFlag: -1,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      visibilityList: [
        {
          value: '公开',
          label: '公开'
        },
        {
          value: '私密',
          label: '私密'
        },
      ],

      total: 0,
      totalPage: 0,
      pageSize: 25,
      page: 0,
      reverse: true,
      activities: [],
      scroll: 0,
      picCha: -1,
      picinfClass: 'picinf',
      displayResolution: "",
      isRefresh: false,
      createUserInfo: {},


      haslovechange: false,

      picInfo: {},
      picExif: {},

      picTimes: 1,
      picDeg: 0,
      //图片说明
      descdialogVisible: false,
      message: '',

      //图集说明
      atlasDialogVisible: false,
      atlasInfodesc: '',
      faceLength: 0,
      switechValue: false,
      imgPicHeight: 0,
      peopleDialogVisible: false,
      faceRuleForm: {
        peopleClass: '',
        region: '',
        name: ''
      },
      faceRules: {
        peopleClass: [{ required: true, message: "请选择人物分类", trigger: "blur" }],
        region: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },

      faceData: [
        {
          name: '',
          createname: '',
          peopleId: -1
        },
      ],
      faceid: -1,
      region: [],
      peopleClass: [],
      showLoading: false,
      BigfileId: -1,
      BigfileInfo: '',
      percent: -1,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      seeOrUpdateFace: 0,//查看或者修改人脸
      clickFaceDialog: false,//点击人脸查看或修改
      nowPeopleInfo: '',//当前人脸信息

      showMessageLeft: false,
      showMessageRight: false,

      notify:null,


      //批量操作
      isRemove: false,
      batchList:[],
      chooseText:'全选',

      orderRule:-1,
      orderByKey:'',
    };
  },
  watch: {
    "$store.state.user.loveList"(data) {
      this.loveList = data;
      // console.log(data)
    },
    "$store.state.user.bigImage"(newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.imgPicHeight = parseInt(sessionStorage.getItem('imgPicHight'))
      this.listPeopleFaceByFileIdAsync(this.BigfileId, this.BigfileInfo)
    }
  },
  methods: {

    ...mapActions(["setLoveList"]),
    determine(){
            if(this.input==''){
          this.$message({
          showClose: true,
          message: '请输入标题',
          type: 'warning'
        });
      }else{
      let params={
          createUid: localStorage.getItem('createUid'),
          downloadConfig:{
            thumb:''
          },
          packageType: "download",
          pictureCount: 1,
          pictureIds: this.downloadimgobj.id,
          title: this.input
      }
      if(this.radio==0){
        params.downloadConfig.thumb = 'high'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==1){
        params.downloadConfig.thumb = 'middle'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==2){
        params.downloadConfig.thumb = 'original'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)
      }else if(this.radio==3){
        params.downloadConfig.thumb = 'small'
        params.downloadConfig=JSON.stringify(params.downloadConfig)
        this.addPicturePackageapi(params)

      }
        this.dialogVisibledefinition=false
      }

    },
    downloadimg(val){
    this.downloadimgobj=val
    this.dialogVisibledefinition=true
    },
    addPicturePackageapi(val){
      addPicturePackage(val).then(res=>{
        if(res.status){
          this.$router.push('/shareAndPush/myDownload')
        }
      })
    },
    changeTableSort(column){
      //获取字段名称和排序类型
      var fieldName = column.prop;
      var sortingType = column.order;

      this.picList = this.picList.filter((e) => e.type !== "pic");

      // console.log(column);

      if(sortingType == "descending"){
        if(fieldName == 'fileSize'){
          this.orderRule = 0
          this.orderByKey = 'fileSize'
          this.handleCurrentChange(1)
        }

        if(fieldName == 'createAtUp'){
          this.orderRule = 0
          this.orderByKey = 'fileCreateAt'
          this.handleCurrentChange(1)
        }
      }else if(sortingType == "ascending"){
        if(fieldName == 'fileSize'){
          this.orderRule = 1
          this.orderByKey = 'fileSize'
          this.handleCurrentChange(1)
        }

        if(fieldName == 'createAtUp'){
          this.orderRule = 1
          this.orderByKey = 'fileCreateAt'
          this.handleCurrentChange(1)
        }
      }else{
        if(fieldName == 'fileSize'){
          this.orderRule = -1
          this.orderByKey = ''
          this.handleCurrentChange(1)
        }

        if(fieldName == 'createAtUp'){
          this.orderRule = -1
          this.orderByKey = 'fileCreateAt'
          this.handleCurrentChange(1)
        }
      }
    },

    addplLabel() {
      if (this.batchList.length == 0) {
        this.$message.warning("请选择图片!");
        return false;
      }
      this.addLabelFlag = true;

      this.addLabelCho = 2
    },

    //删除标签
    tagClose(e){
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.choosePicMsg.customLabelsArr.splice(this.choosePicMsg.customLabelsArr.indexOf(e),1)
          this.choosePicMsg.customLabels = this.choosePicMsg.customLabelsArr.join(',')
          this.$forceUpdate()
          this.updatePictureAsync(this.choosePicMsg)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //新增手动标签
    changeLabel(val) {
      // return
      if(this.addLabelCho == 0){
        if(this.choosePicMsg.hasOwnProperty('customLabelsArr')){
          this.choosePicMsg.customLabelsArr.push(val)
          this.choosePicMsg.customLabels = this.choosePicMsg.customLabelsArr.join(',')

          this.picList[this.choosePicMsg.myId].customLabels = this.choosePicMsg.customLabels
          this.$forceUpdate()
          // console.log('有值修改',this.choosePicMsg);
          this.updatePictureAsync(this.choosePicMsg)
          this.labelhandleClose()
          this.batchList = []
        }else{
          this.choosePicMsg.customLabels = val
          this.choosePicMsg.customLabelsArr = []
          this.choosePicMsg.customLabelsArr.push(val)
          this.picList[this.choosePicMsg.myId].customLabels = this.choosePicMsg.customLabelsArr.toString()
          this.$forceUpdate()
          // console.log('无值修改',this.choosePicMsg);
          this.updatePictureAsync(this.choosePicMsg)
          this.labelhandleClose()
          this.batchList = []
        }
      }else if(this.addLabelCho == 1){
        if(this.choosePicMsg.hasOwnProperty('customLabelsArr')){
          this.choosePicMsg.customLabelsArr.push(val)
          this.choosePicMsg.customLabels = this.choosePicMsg.customLabelsArr.join(',')

          this.picList[this.choosePicMsg.myId].customLabels = this.choosePicMsg.customLabels
          this.$forceUpdate()
          // console.log('有值修改',this.choosePicMsg);
          this.updateVideoAsync(this.choosePicMsg)
          this.labelhandleClose()
          this.batchList = []
        }else{
          this.choosePicMsg.customLabels = val
          this.choosePicMsg.customLabelsArr = []
          this.choosePicMsg.customLabelsArr.push(val)
          this.picList[this.choosePicMsg.myId].customLabels = this.choosePicMsg.customLabelsArr.toString()
          this.$forceUpdate()
          // console.log('无值修改',this.choosePicMsg);
          this.updateVideoAsync(this.choosePicMsg)
          this.labelhandleClose()
          this.batchList = []
        }
      }else{
        for (let i = 0; i < this.plList.length; i++) {
          if(this.plList[i].type == 'pic'){
            if(this.plList[i].hasOwnProperty('customLabels')){
              if(this.plList[i].customLabels){
                this.plList[i].customLabelsArr = this.plList[i].customLabels.split(',')
                this.plList[i].customLabelsArr.push(val)
                this.plList[i].customLabels = this.plList[i].customLabelsArr.join(',')
                this.$forceUpdate()
                this.updatePictureAsync(this.plList[i])
                this.labelhandleClose()
                this.batchList = []
              }else{
                this.plList[i].customLabels = val
                this.updatePictureAsync(this.plList[i])
                this.labelhandleClose()
                this.batchList = []
              }
            }else{
              this.plList[i].customLabels = val
              this.$forceUpdate()
              this.updatePictureAsync(this.plList[i])
              this.labelhandleClose()
              this.batchList = []
            }
          }else if(this.plList[i].type == 'video'){
            if(this.plList[i].hasOwnProperty('customLabels')){
              if(this.plList[i].customLabels){
                this.plList[i].customLabelsArr = this.plList[i].customLabels.split(',')
                this.plList[i].customLabelsArr.push(val)
                this.plList[i].customLabels = this.plList[i].customLabelsArr.join(',')
                this.$forceUpdate()
                this.updateVideoAsync(this.plList[i])
                this.labelhandleClose()
                this.batchList = []
              }else{
                this.plList[i].customLabels = val
                this.updateVideoAsync(this.plList[i])
                this.labelhandleClose()
                this.batchList = []
              }
            }else{
              this.plList[i].customLabels = val
              this.$forceUpdate()
              this.updateVideoAsync(this.plList[i])
              this.labelhandleClose()
              this.batchList = []
            }
          }
        }
        this.isRemove = false
      }
    },
    labelhandleClose() {
      this.addLabelFlag = false;
    },
    openAddLabel(){
      this.addLabelFlag = true;
      this.addLabelCho = 0
    },

    openAddLabelVideo(){
      this.addLabelFlag = true;
      this.addLabelCho = 1
    },

    //表格分页
    handleCurrentChange (val) {
      this.page = val - 1
      let data = { orderRule:this.orderRule, orderByKey :this.orderByKey, atlasId: this.$route.query.id, page: this.page , pageSize: this.pageSize }
      // console.log(data)
      this.listAtlasPicturesAsync(data)
    },

    //批量操作
    batch(){
      this.isRemove = true
      // this.chooseType(0)

      this.picFlag = true;
      let picList = this.choosedata.filter((e) => e.type == "pic");
      let videoList = this.choosedata.filter((e) => e.type == "video");

      this.picList = videoList.concat(picList)

      if(this.picList.length < 1){
        this.picFlag = false
      }
    },
    //取消
    closeremove(){
      this.isRemove = false
      this.isHasVideo = true
      this.chooseText = "全选";
      this.batchList = []
      this.plList = []
      this.chooseType(-1)
    },
    choosePic(e){
      if(this.batchList.indexOf(e.id) !== -1){
        this.batchList.splice(this.batchList.indexOf(e.id),1)
        this.plList.splice(this.plList.indexOf(e),1)
        if(this.batchList.length == 0){
          this.chooseText = '全选'
        }
      }else{
        this.batchList.push(e.id)
        this.plList.push(e);
        this.chooseText = '取消全选'
      }

      let flag = 0
      for (let i = 0; i < this.plList.length; i++) {
        if(this.plList[i].type == 'video'){
          flag++
        }
      }      

      if(flag > 0){
        this.isHasVideo = false
      }else{
        this.isHasVideo = true
      }
      
    },
    //全选
    allChoose(){
      if(this.batchList.length == 0){
        this.chooseText = '取消全选'
        for (let i = 0; i < this.picList.length; i++) {
          this.batchList.push(this.picList[i].id)
          this.plList.push(this.picList[i]);
        }
      }else{
        this.chooseText = '全选'
        this.batchList = []
        this.plList = []
      }

      let flag = 0
      for (let i = 0; i < this.plList.length; i++) {
        if(this.plList[i].type == 'video'){
          flag++
        }
      }      

      if(flag > 0){
        this.isHasVideo = false
      }else{
        this.isHasVideo = true
      }
    },

    //批量移除
    allDel(){
      if(this.batchList.length == 0){
        this.$message.warning('请选择图片!')
        return false;
      }
      this.$confirm("确认删除选中图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(async () => {
          for (let i = 0; i < this.batchList.length; i++) {
            await removePicturePic(this.batchList[i]);
            if(i == this.batchList.length - 1){
              this.$message.success("删除成功！")
              this.isRemove = false
              this.batchList = []
              setTimeout(() => {
                this.refresh()
              }, 1000);
            }
          }
        })
    },


    delWord(e){
      this.$confirm("确认删除吗？", {
        confirmButtonClass: this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm",
      })
        .then((item) => {
          this.deleteDocumentAsync({
            id:e.id
          })
        })
    },
    //删除文稿
    async deleteDocumentAsync(val) {
      let { status, data, message, errors } = await deleteDocument(
        val
      );

      if(status){
        this.$message.success('删除成功！')
        setTimeout(() => {
          this.refresh()
        }, 1500);
      }
    },

    //将视频删除之后放到回收站
    deleteVideo (e) {
      this.$confirm("确认删除之后放到回收站吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if(e.id){
            this.removeVideoAsync(e.id)
          }else{
            this.removeVideoAsync(this.choosePicMsg.id)
          }
        })
    },
    //将视频移除图集到回收站
    async removeVideoAsync (val) {
      let { status, data, message, pagination, errors } = await removeVideo(val);
      if (status) {
        this.$message.success("删除成功！")
        this.dialogVisible = false
        setTimeout(() => {
          this.refresh()
        }, 1000);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    preWord(e){
      this.wordPreMessage = e.content
      this.wordPrePic = e.pictureList
      for (let i = 0; i < this.wordPrePic.length; i++) {
        if(this.wordPrePic[i].levelPath.indexOf('http') == -1){
          this.wordPrePic[i].src = this.picPrefix + this.wordPrePic[i].levelPath
        }else{
          this.wordPrePic[i].src = this.wordPrePic[i].levelPath
        }
      }

      this.wordDialogPre = true
    },

    //修改文稿
    changeWord(e){
      this.$router.push({
        path: '/addword',
        query:{
          id:e.id
        }
      })
    },

    //下载文稿
    downloadWord(e){
      let path
      if(e.path.indexOf('http') == -1){
        path =  this.picPrefix +  e.path
      }else{
        path =  e.path
      }
      this.notify = this.$notify({
        message: '文稿正在后台下载，请耐心等待！',
        position: 'bottom-right',
        duration: 0,
        showClose:false
      });
      var xhr = new XMLHttpRequest();
      xhr.open('GET', path, true);
      xhr.responseType = 'blob';    // 返回类型blob
      let self = this
      xhr.onload = function () {
        if (xhr.status === 200) {

            //创建下载日志
            self.addLogAsync({
              createAt:this.createUid,
              action: 'download',
              resourceType: 'document',
              resourceId: e.id
            })

            self.notify['message'] = '文稿下载成功！'
            self.notify['showClose'] = true
            let blob = this.response;
            // 转换一个blob链接
            let u = window.URL.createObjectURL(new Blob([blob]))
            let a = document.createElement('a');
            a.download = `${e.title ? e.title : '文稿下载'}.docx`;
            a.href = u;
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click();
            a.remove();
            window.URL.revokeObjectURL(u);
        }else{
          self.notify['message'] = '文稿下载出错！'
          self.notify['showClose'] = true
        }
        self.notify['showClose'] = true
      };
      xhr.send()
    },

    //创建日志
    async addLogAsync(val) {
      await addLog(
        val
      );
    },
    //下载视频
    download(e){
      this.notify = this.$notify({
        message: '视频正在后台下载，请耐心等待！',
        position: 'bottom-right',
        duration: 0,
        showClose:false
      });
      var xhr = new XMLHttpRequest();
      xhr.open('GET', e.savepath, true);
      xhr.responseType = 'blob';    // 返回类型blob
      let self = this
      xhr.onload = function () {
        if (xhr.status === 200) {

            //创建下载日志
            self.addLogAsync({
              createAt:this.createUid,
              action: 'download',
              resourceType: 'video',
              resourceId: e.id
            })

            self.notify['message'] = '视频下载成功！'
            self.notify['showClose'] = true
            let blob = this.response;
            // 转换一个blob链接
            let u = window.URL.createObjectURL(new Blob([blob]))
            let a = document.createElement('a');
            a.download = `${e.desc ? e.desc : '视频下载'}.mp4`;
            a.href = u;
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click();
            a.remove();
            window.URL.revokeObjectURL(u);
        }else{
          self.notify['message'] = '视频下载出错！'
          self.notify['showClose'] = true
        }
        self.notify['showClose'] = true
      };
      xhr.send()
    },

    chooseType(i) {
      this.picFlag = true
      if (i == this.chooseFlag) {
        this.chooseFlag = -1
        this.picList = JSON.parse(JSON.stringify(this.choosedata))
      } else {
        this.chooseFlag = i
        switch (i) {
          case 0:
            this.picList = this.choosedata.filter((e) => e.type == 'pic')
            if (this.picList.length < 1) {
              this.picFlag = false
            }
            break;
          case 1:
            this.picList = this.choosedata.filter((e) => e.type == 'video')
            if (this.picList.length < 1) {
              this.picFlag = false
            }
            break;
          case 2:
            this.picList = this.choosedata.filter((e) => e.type == 'word')
            if (this.picList.length < 1) {
              this.picFlag = false
            }
            break;
          default:
            this.picList = JSON.parse(JSON.stringify(this.choosedata));
            if (this.picList.length < 1) {
              this.picFlag = false;
            }
            break;
        }

      }
    },

    seepersonallface(e) {
      if (e.peopleName.indexOf('未命名') !== -1) {
        this.$message.warning('未命名人脸无法查询！')
        return false
      }
      this.dialogVisible = false

      this.$router.push({
        path: '/myLib/seepersonface',
        query: {
          id: e.peopleId,
          title: e.peopleName,
          count: 0
        }
      })
    },


    async clickFaceDialogFun() {  //确认修改或者查看人脸
      if (this.seeOrUpdateFace == 1) {
        this.faceid = this.nowPeopleInfo.faceId
        this.index = this.nowPeopleInfo.index
        if (this.nowPeopleInfo.peopleName.indexOf('未命名') !== -1) {
          this.peopleDialogVisible = true
          this.getPeopleConstantAsync()
        } else {
          this.peopleDialogVisible = true
          this.getPeopleConstantAsync()
        }
      } else if (this.seeOrUpdateFace == 2) {
        console.log(this.nowPeopleInfo);
        setTimeout(() => {
          this.$refs.seePeopleFace.getInfo(this.nowPeopleInfo)
        }, 200);
      } else {
        this.$message.warning('请选择修改或查看！')
      }
    },
    clickFaceDialogHandleClose() {
      this.clickFaceDialog = false
      this.seeOrUpdateFace = 0
    },
    //图片右击
    rightShow(e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },


    seeBigSmall() {
      // this.switechValue = false
      // console.log(1);
      // this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      this.$store.commit('SET_BigImage', !this.$store.state.user.bigImage)
      if (this.$store.state.user.bigImage) {
        fullScreen(this.$refs.imgBj)

        this.seeFull = true
      } else {
        exitFullscreen()

        this.seeFull = false
      }
    },
    mergeFace(scope) {
      this.$confirm('确认合并吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then((es) => {
        let val = {
          faceId: this.faceid,
          peopleId: scope.row.id,
          similarity: 0
        }
        this.faceRuleForm.name = scope.row.peopleName
        this.setPeopleFaceAccessAsync(val);
        this.clickFaceDialog = false;
        this.nowPeopleInfo.peopleId = scope.row.id
      })
    },
    myInput(item) {
      let val
      if (item.length >= 1) {
        this.faceInputFlag = true
        val = {
          name: item,
          fuzzySearch: true
        }
        this.listPeopleAsync(val)
      } else {
        this.faceInputFlag = false
      }
    },
    async listPeopleAsync(val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.faceData = data
        for (let i = 0; i < data.length; i++) {

          data[i].peopleLogo = picPrefix + data[i].peopleLogo

          if (data[i].peopleName === this.faceRuleForm.name) {
            this.showSureBtn = false
            console.log(1);
          } else {
            this.showSureBtn = true
            console.log(2);
          }
          console.log(this.showSureBtn);
          console.log(data[i].peopleName, this.faceRuleForm.name);
        }
        if (data.length == 0) {
          this.showSureBtn = true
        }
      }
    },
    getFaceId(num, item, index) {
      // this.clickFaceDialog = true
      this.nowPeopleInfo = item
      this.nowPeopleInfo.index = index
      this.seeOrUpdateFace = num
      this.clickFaceDialogFun()

      // this.faceid = item.faceId
      // this.index = index
      // if (item.peopleName == '未设置') {
      //   this.peopleDialogVisible = true
      //   this.getPeopleConstantAsync()
      // } else {
      //   this.$confirm('确认修改吗12?', '', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消'
      //   }).then(() => {
      //     this.peopleDialogVisible = true
      //     this.getPeopleConstantAsync()
      //   }).catch(() => {
      //   });
      // }
    },
    beSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let val = {
            peopleClass: this.faceRuleForm.peopleClass,
            region: this.faceRuleForm.region,
            peopleName: this.faceRuleForm.name
          }
          this.peopleLoading = true
          this.addPeopleAsync(val)
          this.clickFaceDialog = false
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async addPeopleAsync(val) {
      let { status, data, message, errors } = await addPeople(val)
      if (status) {
        let value = {
          faceId: this.faceid,
          peopleId: data.id,
          similarity: 0
        }
        this.nowPeopleInfo.peopleId = data.id
        // console.log(value);
        this.setPeopleFaceAccessAsync(value);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });

      }
      this.peopleLoading = false
    },
    async setPeopleFaceAccessAsync(val) {
      let { status, data, message, errors } = await setPeopleFaceAccess(val);
      if (status) {
        this.$message.success(message)
        this.peopleDialogVisible = false
        // console.log(1);
        this.choosePicMsg.faceInfo[this.index].peopleName = this.faceRuleForm.name
        this.faceRuleForm = {}
        this.faceInputFlag = false

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        console.log(2);
      }
      this.peopleLoading = false
    },
    async getPeopleConstantAsync() {
      let { status, data, message } = await getPeopleConstant();
      this.region = data.region
      this.peopleClass = data.peopleClass
    },

    handleClose() {
      this.faceRuleForm = {}
      this.faceData = {}
      this.faceInputFlag = false
      this.peopleDialogVisible = false
      this.clickFaceDialog = false
    },

    openFace() {
      // this.switechValue = true
    },

    //修改图集说明
    openAtlasDesc() {
      this.atlasDialogVisible = true
      this.atlasInfodesc = this.atlasInfo.desc
    },
    handleCloseAtlas() {
      this.atlasDialogVisible = false
    },
    changeAtlasDesc() {
      this.atlasInfo.desc = this.atlasInfodesc
      this.updateAtlasAsync(this.atlasInfo)
      this.atlasDialogVisible = false
    },
    //修改图集说明
    async updateAtlasAsync(val) {
      let { status, data, message } = await updateAtlas(val);
      if (status) {
        this.$message.success("修改成功！")
        this.refresh()
      }
    },


    //修改图片说明
    changeDesc(val) {
        if(val.type=='video'){
        let obj=JSON.parse(JSON.stringify(val.exif.exif))
        obj.CreateAt= moment(obj.CreateAt).unix()
        setExtInfoapi({id:val.fileId},JSON.stringify(obj)).then(res=>{
        if(res.status){
        this.$message.success("修改成功！");
        }
       })
      }else{ 
       setExtInfoapi({id:val.fileId},JSON.stringify(val.fileExif)).then(res=>{
        if(res.status){
        this.$message.success("修改成功！");
        }
      })
      }
      if(val.type == 'pic'){
        this.updatePictureAsync(val)
      }else{
        this.updateVideoAsync(val)
      }
      this.descdialogVisible = false
    },
    deschandleClose() {
      this.descdialogVisible = false
    },
    openChangeDesc(val) {
      this.message = val;
       val.typeimg='img'
      if(this.message.fileExif==null){
          this.message.fileExif={}
       }
       if(!this.message.fileExif.author){
         this.message.fileExif.author=''
       }else{
       this.$refs.openChangeDescs.data=this.message.fileExif.author
       }
   
      this.descdialogVisible = true;
    },
    openChangeDescvideo(val) {
      val.type='video'
      if(val.exif==null){ 
       val.exif={}
        val.exif.exif={}
        val.exif.exif.CreateAt=''
        val.exif.exif.videoAddress=''
        val.exif.exif.videoCharacter=''
        val.exif.exif.videoEvent=''
        val.exif.exif.videoClassification=''
        this.message =JSON.parse(JSON.stringify(val)) 
      }else{  
      this.message=val        
      this.message.exif.exif= typeof this.message.exif.exif=='string' ?  JSON.parse(this.message.exif.exif):this.message.exif.exif
      if( this.message.exif.exif.CreateAt){
        if(this.message.exif.exif.CreateAt<9999999999){
          this.message.exif.exif.CreateAt =moment(moment.unix(this.message.exif.exif.CreateAt).format('YYYY-MM-DD')).valueOf() 
        }
       }
      }
      this.descdialogVisible = true
    },
    //修改视频说明
    async updateVideoAsync(val) {
      let { status, data, message, errors } = await updateVideo(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //修改图片说明
    async updatePictureAsync(val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图片放大
    picLarge() {
      this.picTimes += 1.5
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 6
        this.$refs.imgPic.style.transform = 'scale(6) rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片缩小
    picSmall() {
      this.picTimes -= 1.5
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 1
        this.$refs.imgPic.style.transform = 'scale(1) rotateZ(' + this.picDeg + 'deg)';
      }
    },

    //图片旋转
    picRotateLeft() {
      this.switechValue = false
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight() {
      this.switechValue = false
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //清除放大缩小效果
    clearLargeAndSmall() {
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    lovePicOut(i, e) {
      if (this.picList[i].errortext == 'error') {
        this.$message.warning('图片生成失败，无法添加到选用图片!');
        return false
      }
      this.choosePicMsg = e
      this.choosePicMsg.myId = i
      this.lovePic()
    },

    //查看人脸
    seeFace() {
      this.switechValue = !this.switechValue
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    //图片选用
    lovePic() {
      if (this.picList[this.choosePicMsg.myId].errortext == 'error') {
        this.$message.warning('图片生成失败，无法添加到选用图片!');
        return false
      }
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)




      if (picLoveArray == null) {
        this.choosePicMsg.isLove = false
        this.haslovechange = false
      } else {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }

      if (!this.choosePicMsg.isLove) {

        // if (picLoveArray !== null) {
        //   if (picLoveArray.length > 34) {
        //     this.$message.warning('选用图片最多35张!');
        //     return false
        //   }
        // }

        this.loveList.push(this.choosePicMsg.id)
        this.setLoveList(this.loveList)
        this.choosePicMsg.isLove = true

        this.haslovechange = true

        if (!picLoveArray) {
          let pL = []
          pL.push(this.choosePicMsg)
          sessionStorage.setItem("picLove", JSON.stringify(pL));
          this.setUserSettingAsync(this.createUid, 'picLove', { value: this.choosePicMsg.id })
          this.$message.success("添加成功")
        } else {
          picLoveArray.push(this.choosePicMsg)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("添加成功")
        }
      } else {
        this.loveList.splice(this.loveList.indexOf(this.choosePicMsg.id), 1)
        this.setLoveList(this.loveList)

        this.choosePicMsg.isLove = false

        this.haslovechange = false

        if (picLoveArray.length === 1) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.$message.success("移出成功")
        } else {
          let f
          for (let i = 0; i < picLoveArray.length; i++) {
            if (this.choosePicMsg.id === picLoveArray[i].id) {
              f = i
            }
          }
          // console.log(picLoveArray)
          picLoveArray.splice(f, 1)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("移出成功")
        }

      }

      console.log(this.choosePicMsg.isLove)

    },



    //设置选用图片
    async setUserSettingAsync(val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选用图片
    // async getUserSettingAsync (val, val2) {
    //   let { status, data, message, errors } = await getUserSetting(val, val2);
    //   if (status) {
    //     return
    //     let piclove = JSON.parse(data)
    //     sessionStorage.setItem('picLove', piclove.value)
    //   } else {
    //     let errortext = ''
    //     for (const key in errors) {
    //       errortext += errors[key]
    //     }
    //     this.$message.error({ message: message + errortext });
    //   }
    // },
    //获取选用图片
    async getUserSettingAsync(val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let piclove = JSON.parse(data);
        // console.log(piclove);
        if (piclove.value == null) {
          // sessionStorage.removeItem("picLove");
        } else {

          let picIds = []
          for (let i = 0; i < piclove.value.length; i++) {
            picIds.push(piclove.value[i].id)
          }
          picIds = picIds.join(',');
          // console.log(picIds);
          let idsInfo = await getPictures({ ids: picIds });
          for (let j = 0; j < idsInfo.data.length; j++) {
            idsInfo.data[j].srcW1080 = this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080
            idsInfo.data[j].src = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
          }
          // console.log(idsInfo.data);
          sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },


    dev() {
      this.$message("正在开发中……")
    },


    //刷新
    refresh() {

      this.isRefresh = true
      this.atlasInfo = []
      this.chooseFlag = -1
      this.picList = []
      this.choosedata = []
      this.createUserInfo = []
      this.activities = []
      this.displayResolution = document.documentElement.clientWidth

      
      this.page = 0

      this.listAtlasVideosAsync({
        id: this.$route.query.id,
        page: 0,
        pageSize: 20
      },1)
      setTimeout(() => {
        this.isRefresh = false
      }, 888);

      setTimeout(() => {
        this.getAtlasInfoAsync(this.$route.query.id)
      }, 1000);
    },








    ...mapActions(["setIsUpload"]),
    //判断选中的图片在什么位置
    beSurePic(i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth
        let piclistwidth = this.$refs.piclist.offsetWidth
        this.scroll = i * -80
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70
          this.picCha = this.scroll

        }
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0
      }
    },




    //补充图片
    supplyPic() {
      if(this.atlasInfo.hasOwnProperty('id')){
        this.$router.push({
          //核心语句
          name: "pictureUpload", //跳转的路径
          params: {
            //路由传参时push和query搭配使用 ，作用时传递参数
            atlas: this.atlasInfo
          }
        });
      }else{
        this.$message.warning('获取图集信息失败，请刷新页面！')
      }
      
    },

    //删除图集
    deleteAtlas() {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deleteAtlasAsync(this.atlasInfo.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },


    //图集取消归档
    unFormatAtlasClick() {
      this.$confirm("确定取消归档图集吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.unFormatAtlasAsync(this.atlasInfo.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },

    //将图片删除之后放到未整理
    removePic (e) {
      this.$confirm("确认移出至未整理中吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let params
          if(e.id){
            params = {
              atlasId: this.$route.query.id,
              pictureId: e.id
            }
          }else{
            params = {
              atlasId: this.$route.query.id,
              pictureId: this.choosePicMsg.id
            }
          }
          // this.unFormatAtlasAsync(this.atlasInfo.id)
          this.removePictureAtlasAsync(params)
        })
    },

    //将图片删除
    deletePic(e) {
      this.$confirm("确认删除之后放到回收站吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if(e.id){
            this.removePicturePicAsync(e.id)
          }else{
            this.removePicturePicAsync(this.choosePicMsg.id)
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },


    //将图片设为封面
    setIndexPic() {
      this.$confirm("是否将该图片设置为封面?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let params = {
            atlasId: this.$route.query.id,
            pictureId: this.choosePicMsg.id
          }
          // this.unFormatAtlasAsync(this.atlasInfo.id)
          this.setIndexpicAsync(params)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },



    //获取图片信息
    getPicInfo(e) {

      if(e.type == 'pic'){
        this.picInfo.picH = e.picH || "1920";
        this.picInfo.picW = e.picW || "1080";
        this.picInfo.format = e.ext || "jpg";
        this.picInfo.createAt = formatConversion(
          e.fileCreateAt.toString()
        ).substring(0, 10);
        this.picInfo.fileSize = e.fileSize;


        if(e.fileExif){
          if (e.fileExif.hasOwnProperty("CreateAt")) {
            this.picExif.CreateAtMy = "";
            this.picExif.CreateAtMy = formatConversion(
              e.fileExif.CreateAt.toString()
            ).substring(0, 10);
          } else {
            this.picExif.CreateAtMy = null;
          }
        }else{
          this.picExif.CreateAtMy = null;
        }

        this.choosePicMsg.faceInfo = [];
        this.BigfileId = e.fileId;
        this.BigfileInfo = e;
        this.listPeopleFaceByFileIdAsync(e.fileId, e);

      }else{
        this.picInfo.picH = e.fileInfo.picH || '1920'
        this.picInfo.picW = e.fileInfo.picW || '1080'
        this.picInfo.format = (e.fileInfo.savepath).substring(e.fileInfo.savepath.length - 3) || 'jpg'
        this.picInfo.createAt = formatConversion(e.fileInfo.createAt.toString()).substring(0, 10)
        this.picInfo.fileSize = (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || '暂无'

        if (e.exif) {
          this.picExif = e.exif
          if (e.exif.CreateAt) {
            this.picExif.CreateAtMy = formatConversion(e.exif.CreateAt.toString()).substring(0, 10)
            // if (this.picExif.CreateAt) {
              
            // } else {
              
            // }
          } else {
            // this.picExif.CreateAtMy = formatConversion(this.picExif.CreateAt.toString()).substring(0, 10)
            this.picExif.CreateAtMy = null
          }
        }
      }
      
      
    },




    openUpload() {
      this.setIsUpload(false)
    },
    closeUpload() {
      this.setIsUpload(true)
    },
    async openDialog(i, e) {
      console.log(e);
      if(e.fileExif){
        this.dataimgzuozhe=e.fileExif.author
     }
      if(e.exif){
        if(typeof e.exif.exif =='string' ){
          this.datavideozuozhe= JSON.parse(e.exif.exif) 
        }else{
           this.datavideozuozhe=e.exif.exif
        }
      }
      this.switechValue = false
      this.dialogVisible = true
      this.choosePicMsg = { isLove: false, faceInfo: [] }

      // this.switechValue = false
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.type = e.type
      this.choosePicMsg.id = e.id
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.errortext = ''
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext
      }
      this.choosePicMsg.fileId = e.fileId
      this.choosePicMsg.desc = e.desc
      this.choosePicMsg.downloadCount = e.downloadCount
      this.choosePicMsg.pushCount = e.pushCount
      this.choosePicMsg.shareCount = e.shareCount
      this.choosePicMsg.src = e.srcW1080
      this.choosePicMsg.srcW1080 = e.type == 'pic' ? e.srcW1080 : e.src

      if(e.type == 'video'){
        this.choosePicMsg.libId = e.libId;
        this.choosePicMsg.atlasId = e.atlasId;
        this.playerOptions.sources[0].src = this.choosePicMsg.srcW1080
      }

      //手动标签
      this.choosePicMsg.customLabels = e.customLabels;
      if(this.choosePicMsg.customLabels){
        this.choosePicMsg.customLabelsArr = this.choosePicMsg.customLabels.split(',')
      }else{
        this.choosePicMsg.customLabelsArr = []
      }

      this.choosePicMsg.myId = i
      this.choosePicMsg.faceInfo = []

      this.choosePicMsg.logs = e.logs
      this.choosePicMsg.downloadCount = e.downloadCount
      if(this.choosePicMsg.logs.length > 0){
        for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
          this.choosePicMsg.logs[i].createAtMY = formatConversion(this.choosePicMsg.logs[i].createAt.toString())
          this.choosePicMsg.logs[i].createName = this.choosePicMsg.logs[i].createUserInfo.name
        }
      }

      this.picAllListFlag = i

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }

      if(e.type == 'pic'){
        this.getPictureLogAsync({
          id: this.choosePicMsg.id,
          type: "download",
          pageSize: 100000,
        });
      }

      // let faceInfo = await listPeopleFaceByFileId({ fileId: this.choosePicMsg.fileId })
      // let faceCoord = faceInfo.data


      this.getPicInfo(e)

      this.$nextTick(() => {
        if(e.type == 'pic'){
          this.clearLargeAndSmall()
        }
        this.beSurePic(i, 10)
        sessionStorage.setItem('imgPicHight', this.$refs.imgPic.clientHeight)

      })


      if(e.type == 'pic'){
        setTimeout(() => {
          this.imgPicHeight = this.$refs.imgPic.clientHeight || 279
          this.BigfileId = e.fileId
          this.BigfileInfo = e
          this.listPeopleFaceByFileIdAsync(e.fileId, e)
        }, 1000);
      }
    },
    async listPeopleFaceByFileIdAsync(fileId, fileInfo) {
      // console.log(this.$refs.imgPic.clientHeight);
      // let percent = fileInfo.picH / this.imgPicHeight
      if (this.$store.state.user.bigImage) {
        this.percent = this.picInfo.picH / (window.screen.height)
      } else {
        this.percent = this.picInfo.picH / this.imgPicHeight
      }
      let percent = this.percent
      let { data, message, status } = await listPeopleFaceByFileId({ fileId: fileId });
      // console.log(this.$refs.imgPic.clientHeight, this.$refs.imgPic.clientWidth);
      // console.log(fileInfo.picH, fileInfo.picW);
      if (status) {
        this.choosePicMsg.faceInfo = []
        this.faceLength = data.length
        this.$forceUpdate()
        for (let i = 0; i < data.length; i++) {
          this.faceArr = {}
          let coordArr = data[i].coord.split(',')
          coordArr[0] = Math.round(parseFloat(coordArr[0]) * (fileInfo.picH / percent));
          coordArr[1] = Math.round(parseFloat(coordArr[1]) * (fileInfo.picW / percent));
          coordArr[2] = Math.round(parseFloat(coordArr[2]) * (fileInfo.picH / percent));
          coordArr[3] = Math.round(parseFloat(coordArr[3]) * (fileInfo.picW / percent));
          // console.log(coordArr);
          this.faceArr.width = coordArr[1] - coordArr[3];
          this.faceArr.height = coordArr[2] - coordArr[0];
          this.faceArr.top = Math.round(coordArr[0] - (fileInfo.picH / percent) / 2);
          if (this.$store.state.user.bigImage) {
            this.faceArr.left = Math.round(coordArr[3] - (fileInfo.picW / percent) / 2) - 555 - 390;
          }else{
            this.faceArr.left = Math.round(coordArr[3] - (fileInfo.picW / percent) / 2) - 555;
          }

          this.displayResolution = document.documentElement.clientWidth;
          console.log(document.documentElement.clientWidth,'document.documentElement.clientWidth');
          console.log(this.displayResolution,'this.displayResolution');
          console.log(this.faceArr.left,'this.faceArr.left1');

          if(this.displayResolution < 1540){
            if (this.$store.state.user.bigImage) {
              this.faceArr.left += 180
            }else{
              this.faceArr.left += 110
            }
          }else if(this.displayResolution >= 1540 && this.displayResolution < 1750){
            if (this.$store.state.user.bigImage) {
              this.faceArr.left += 110
            }else{
              this.faceArr.left += 50
            }
          } 

          this.faceArr.faceId = data[i].id
          this.faceArr.peopleId = data[i].peopleId
          if (data[i].peopleInfo === null) {
            let sexArray = ['男', '女']
            if (data[i].sex !== -1 && data[i].age !== -1) {
              this.faceArr.peopleName = `未命名（${data[i].sex !== -1 ? sexArray[data[i].sex] : ''} ${data[i].age !== -1 ? data[i].age + '岁' : ''}）`
            } else {
              this.faceArr.peopleName = `未命名`
            }
            // this.faceArr.peopleName = '未命名' + '(' + data[i].sex !== -1 ? sexArray[data[i].sex] : '' + data[i].age !== -1 ? data[i].age + '岁' : '' + ')'
          } else {
            let sexArray = ['男', '女']
            if (data[i].sex !== -1 && data[i].age !== -1) {
              this.faceArr.peopleName = `${data[i].peopleInfo.peopleName}（${data[i].sex !== -1 ? sexArray[data[i].sex] : ''} ${data[i].age !== -1 ? data[i].age + '岁' : ''}）`
            } else {
              this.faceArr.peopleName = `${data[i].peopleInfo.peopleName}`
            }
            // this.faceArr.peopleName = data[i].peopleInfo.peopleName + '(' + data[i].sex !== -1 ? sexArray[data[i].sex] : '' + data[i].age !== -1 ? data[i].age + '岁' : '' + ')'
          }
          // console.log(this.faceArr);
          this.choosePicMsg.faceInfo.push(this.faceArr)
          this.$forceUpdate()
        }
        // console.log(this.choosePicMsg.faceInfo);
      }
    },
    async picListClick(e, i) {
      // this.clearLargeAndSmall()

      // this.switechValue = false

      this.choosePicMsg.id = e.id
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.errortext = ''
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext
      }
      this.choosePicMsg.type = e.type
      this.choosePicMsg.fileId = e.fileId
      this.choosePicMsg.desc = e.desc
      this.choosePicMsg.downloadCount = e.downloadCount
      this.choosePicMsg.pushCount = e.pushCount
      this.choosePicMsg.shareCount = e.shareCount
      this.choosePicMsg.src = e.type == 'pic' ? e.srcW1080 : e.src
      if(e.type == 'video'){
        this.choosePicMsg.libId = e.libId;
        this.choosePicMsg.atlasId = e.atlasId;
        this.playerOptions.sources[0].src = this.choosePicMsg.src
      }
      this.choosePicMsg.srcW1080 = e.srcW1080
      this.choosePicMsg.myId = i
      this.choosePicMsg.faceInfo = []

      this.choosePicMsg.customLabels = e.customLabels;
      if(this.choosePicMsg.customLabels){
        this.choosePicMsg.customLabelsArr = this.choosePicMsg.customLabels.split(',')
      }else{
        this.choosePicMsg.customLabelsArr = []
      }

      this.choosePicMsg.logs = e.logs
      this.choosePicMsg.downloadCount = e.downloadCount
      if(this.choosePicMsg.logs.length > 0){
        for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
          this.choosePicMsg.logs[i].createAtMY = formatConversion(this.choosePicMsg.logs[i].createAt.toString())
          this.choosePicMsg.logs[i].createName = this.choosePicMsg.logs[i].createUserInfo.name
        }
      }

      if(e.type == 'pic'){
        this.getPictureLogAsync({
          id: this.choosePicMsg.id,
          type: "download",
          pageSize: 100000,
        });
      }


      this.picAllListFlag = i

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }

      // let faceInfo = await listPeopleFaceByFileId({ fileId: this.choosePicMsg.fileId })
      // let faceCoord = faceInfo.data

      this.getPicInfo(e)


    },



    //图片浏览中大的箭头 左边
    async bigLeft() {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return
      }
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }

      // this.switechValue = false
      if(this.picList[this.choosePicMsg.myId - 1].type == 'pic'){
        this.clearLargeAndSmall()
      }

     if( this.picList[this.choosePicMsg.myId - 1].fileExif){
        this.dataimgzuozhe= this.picList[this.choosePicMsg.myId - 1].fileExif.author
     }else{
        this.dataimgzuozhe= ''
     }
      this.choosePicMsg.errortext = ''
      if (this.picList[this.choosePicMsg.myId - 1].errortext) {
        this.choosePicMsg.errortext = this.picList[this.choosePicMsg.myId - 1].errortext
      }
      this.choosePicMsg.type = this.picList[this.choosePicMsg.myId - 1].type
      this.choosePicMsg.fileId = this.picList[this.choosePicMsg.myId - 1].fileId
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId - 1].labels
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId - 1].srcW1080

      this.choosePicMsg.customLabels = this.picList[this.choosePicMsg.myId - 1].customLabels;
      if(this.choosePicMsg.customLabels){
        this.choosePicMsg.customLabelsArr = this.choosePicMsg.customLabels.split(',')
      }else{
        this.choosePicMsg.customLabelsArr = []
      }

      this.choosePicMsg.logs = this.picList[this.choosePicMsg.myId - 1].logs
      this.choosePicMsg.downloadCount = this.picList[this.choosePicMsg.myId - 1].downloadCount
      if(this.choosePicMsg.logs.length > 0){
        for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
          this.choosePicMsg.logs[i].createAtMY = formatConversion(this.choosePicMsg.logs[i].createAt.toString())
          this.choosePicMsg.logs[i].createName = this.choosePicMsg.logs[i].createUserInfo.name
        }
      }

      if(this.choosePicMsg.type == 'video'){
        this.choosePicMsg.libId = this.picList[this.choosePicMsg.myId - 1].libId;
        this.choosePicMsg.atlasId = this.picList[this.choosePicMsg.myId - 1].atlasId;
        this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId - 1].src
        this.playerOptions.sources[0].src = this.choosePicMsg.srcW1080
        console.log( this.picList[this.choosePicMsg.myId - 1]);
          if(  this.picList[this.choosePicMsg.myId - 1].exif){
              if(typeof   this.picList[this.choosePicMsg.myId - 1].exif.exif =='string' ){
                this.datavideozuozhe= JSON.parse(  this.picList[this.choosePicMsg.myId - 1].exif.exif) 
              }else{
                this.datavideozuozhe=  this.picList[this.choosePicMsg.myId - 1].exif.exif
              }
          }else{
             this.datavideozuozhe=''
          }
          console.log(this.datavideozuozhe);
      }else{
        this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId - 1].srcW1080
      }

      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId - 1].desc
      this.choosePicMsg.downloadCount = this.picList[this.choosePicMsg.myId - 1].downloadCount
      this.choosePicMsg.pushCount = this.picList[this.choosePicMsg.myId - 1].pushCount
      this.choosePicMsg.shareCount = this.picList[this.choosePicMsg.myId - 1].shareCount
      this.choosePicMsg.faceInfo = []
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId - 1].id

      if(this.choosePicMsg.type == 'pic'){
        this.getPictureLogAsync({
          id: this.choosePicMsg.id,
          type: "download",
          pageSize: 100000,
        });
      }

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }


      this.getPicInfo(this.picList[this.choosePicMsg.myId - 1])

      // let faceInfo = await listPeopleFaceByFileId({ fileId: this.choosePicMsg.fileId })
      // let faceCoord = faceInfo.data

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0
        this.picCha = -1
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      }


      // this.$nextTick(() => {

      //   for (let facei = 0; facei < faceCoord.length; facei++) {
      //     faceCoord[facei].coord = faceCoord[facei].coord.split(",")
      //     // console.log(this.$refs.imgPic.offsetHeight);
      //     // console.log(this.$refs.imgPic.offsetWidth);
      //     faceCoord[facei].top = Math.round(faceCoord[facei].coord[0] * this.$refs.imgPic.clientHeight, 2)
      //     faceCoord[facei].right = Math.round(faceCoord[facei].coord[1] * this.$refs.imgPic.clientWidth, 2)
      //     faceCoord[facei].bottom = Math.round(faceCoord[facei].coord[2] * this.$refs.imgPic.clientHeight, 2)
      //     faceCoord[facei].left = Math.round(faceCoord[facei].coord[3] * this.$refs.imgPic.clientWidth, 2)

      //     faceCoord[facei].postop = faceCoord[facei].top - this.$refs.imgPic.clientHeight / 2 - 3
      //     faceCoord[facei].posleft = faceCoord[facei].left - this.$refs.imgPic.clientWidth / 2 - 3

      //   }
      // })



      // setTimeout(() => {
      //   for (let i = 0; i < faceCoord.length; i++) {
      //     let faceArry = {}
      //     faceArry.height = faceCoord[i].bottom - faceCoord[i].top
      //     faceArry.width = faceCoord[i].right - faceCoord[i].left

      //     faceArry.postop = faceCoord[i].postop
      //     faceArry.posleft = faceCoord[i].posleft
      //     this.choosePicMsg.faceInfo.push(faceArry)
      //   }
      // }, 200);
    },

    //图片浏览中大的箭头 右边
    async bigRight() {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return
      }
      // this.switechValue = false
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      if(this.picList[this.choosePicMsg.myId + 1].type == 'pic'){
        // this.clearLargeAndSmall()
        if(this.picList[this.choosePicMsg.myId + 1].fileExif){
              this.dataimgzuozhe=this.picList[this.choosePicMsg.myId + 1].fileExif.author
          }else{
           this.dataimgzuozhe=''
          }
      }

      this.choosePicMsg.errortext = ''
      if (this.picList[this.choosePicMsg.myId + 1].errortext) {
        this.choosePicMsg.errortext = this.picList[this.choosePicMsg.myId + 1].errortext
      }
      this.choosePicMsg.type = this.picList[this.choosePicMsg.myId + 1].type
      this.choosePicMsg.fileId = this.picList[this.choosePicMsg.myId + 1].fileId
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId + 1].labels
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId + 1].srcW1080
      
      if(this.choosePicMsg.type == 'video'){
        console.log(this.picList);
        if(  this.picList[this.choosePicMsg.myId + 1].exif){
        if(typeof   this.picList[this.choosePicMsg.myId + 1].exif.exif =='string' ){
          this.datavideozuozhe= JSON.parse(  this.picList[this.choosePicMsg.myId + 1].exif.exif) 
        }else{
           this.datavideozuozhe=  this.picList[this.choosePicMsg.myId + 1].exif.exif
        }
      }
        this.choosePicMsg.libId = this.picList[this.choosePicMsg.myId + 1].libId;
        this.choosePicMsg.atlasId = this.picList[this.choosePicMsg.myId + 1].atlasId;
        this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId + 1].src
        this.playerOptions.sources[0].src = this.choosePicMsg.srcW1080
      }else{
        this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId + 1].srcW1080
      }

      this.choosePicMsg.customLabels = this.picList[this.choosePicMsg.myId + 1].customLabels;
      if(this.choosePicMsg.customLabels){
        this.choosePicMsg.customLabelsArr = this.choosePicMsg.customLabels.split(',')
      }else{
        this.choosePicMsg.customLabelsArr = []
      }

      this.choosePicMsg.logs = this.picList[this.choosePicMsg.myId + 1].logs
      this.choosePicMsg.downloadCount = this.picList[this.choosePicMsg.myId + 1].downloadCount
      if(this.choosePicMsg.logs.length > 0){
        for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
          this.choosePicMsg.logs[i].createAtMY = formatConversion(this.choosePicMsg.logs[i].createAt.toString())
          this.choosePicMsg.logs[i].createName = this.choosePicMsg.logs[i].createUserInfo.name
        }
      }


      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId + 1].desc
      this.choosePicMsg.downloadCount = this.picList[this.choosePicMsg.myId + 1].downloadCount
      this.choosePicMsg.pushCount = this.picList[this.choosePicMsg.myId + 1].pushCount
      this.choosePicMsg.shareCount = this.picList[this.choosePicMsg.myId + 1].shareCount
      this.choosePicMsg.faceInfo = []
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId + 1].id

      if(this.choosePicMsg.type == 'pic'){
        this.getPictureLogAsync({
          id: this.choosePicMsg.id,
          type: "download",
          pageSize: 100000,
        });
      }

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)

      this.choosePicMsg.isLove = false
      this.haslovechange = false
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true
            this.haslovechange = true
          }

        }
      }


      this.getPicInfo(this.picList[this.choosePicMsg.myId + 1])


      this.choosePicMsg.myId = this.choosePicMsg.myId + 1

      this.picAllListFlag = this.choosePicMsg.myId
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth
        let piclistwidth = this.$refs.piclist.offsetWidth
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80
          setTimeout(() => {
            this.picCha = this.scroll
          }, 1000);
        }
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      }
    },









    //图片浏览小的箭头 右边
    smallRight() {
      let picalllistwidth = this.$refs.picalllist.offsetWidth
      let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll - 300
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70
        this.picCha = this.scroll
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft() {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + this.scroll + "px)";
      }


      // console.log(this.scroll)
    },


    //获取图片日志
    async getPictureLogAsync(val) {
      let { status, data, message, errors } = await getPictureLog(val);
      if (status) {
        this.choosePicMsg.logs = data;
        if (this.choosePicMsg.logs.length > 0) {
          for (let i = 0; i < this.choosePicMsg.logs.length; i++) {
            this.choosePicMsg.logs[i].createAtMY = formatConversion(
              this.choosePicMsg.logs[i].createAt.toString()
            );
            this.choosePicMsg.logs[i].createName =
              this.choosePicMsg.logs[i].createUserInfo.name;
          }
        }

        this.$forceUpdate()
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },





    checkIsBottom(str, m, n) {
      var re = /(\d+)/g;
      while (re.exec(str)) {
        var int = parseInt(RegExp.$1);
        if (int < m || int > n) return false;
      }
      return true;
    },




    //滚动设置picinf为fixed
    handleScroll() {

      let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop


      let scrollData = document.documentElement.scrollTop + window.innerHeight
      let bodyHeightMin = document.body.offsetHeight - 2
      let bodyHeightMax = document.body.offsetHeight
      // let isBottom = this.checkIsBottom(scrollData, bodyHeightMin, bodyHeightMax)
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;
      if (scrollTop >= 216) {
        this.picinfClass = 'picinf picinfpos'
        // this.picdescribeClass = 'picdescribe picdescribepos'
      } else {
        this.picinfClass = 'picinf'
        // this.picdescribeClass = 'picdescribe'
      }

      if (isBottom) {
        let pic = this.choosedata.filter((e) => e.type == 'pic')
        let picLength = pic.length
        console.log(picLength, this.total);
        if (picLength !== this.total) {
          this.showLoading = true;
          if (this.page == this.totalPage - 1) {
            return false
          }
          this.page++;
          let params = {
            atlasId: this.$route.query.id,
            page: this.page,
            pageSize: this.pageSize
          }
          setTimeout(() => {
            this.listAtlasPicturesAsync(params,1)
          }, 1000);
          // this.showLoading = false;
        }

      }
    },


    //删除图集
    async deleteAtlasAsync(val) {
      // this.$router.go(-1)
      // return
      let { status, data, message, pagination, errors } = await deleteAtlas(val);
      if (status) {
        this.$message.success("删除成功！")
        sessionStorage.setItem('deleteAltasIndex', this.$route.query.index)
        setTimeout(() => {
          this.$router.go(-1)
        }, 500);
        // this.$router.push({
        //   //核心语句
        //   name: "/pictureCenter", //跳转的路径
        //   query: { 'deleteAltasIndex': this.$route.query.index }
        // });
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图集取消归档
    async unFormatAtlasAsync(val) {
      let { status, data, message, pagination, errors } = await unFormatAtlas(val);
      if (status) {
        this.$message.success("取消归档成功！")
        this.$router.push({
          //核心语句
          name: "piccenter", //跳转的路径
        });
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //将图片移除图集到未整理
    async removePictureAtlasAsync(val) {
      let { status, data, message, pagination, errors } = await removePictureAtlas(val);
      if (status) {
        this.$message.success("移出成功！")
        this.dialogVisible = false
        setTimeout(() => {
          this.refresh()
        }, 1000);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //将图片移除图集到回收站
    async removePicturePicAsync (val) {
      let { status, data, message, pagination, errors } = await removePicturePic(val);
      if (status) {
        this.$message.success("删除成功！")
        this.dialogVisible = false
        setTimeout(() => {
          this.refresh()
        }, 1000);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //将图片设为封面
    async setIndexpicAsync(val) {
      let { status, data, message, pagination, errors } = await setIndexpic(val);
      if (status) {
        this.$message.success("设置成功！")

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取图集信息
    async getAtlasInfoAsync(val) {
      let { status, data, message, pagination } = await getAtlasInfo(val);
      if (status) {
        this.atlasInfo = data
        this.atlasInfo.libName = data.libInfo.name
        this.atlasInfo.createUserInfoId = data.createUserInfo.id
        this.atlasInfo.createAtMY = formatConversion(this.atlasInfo.createAt.toString())
        this.createUserInfo = data.createUserInfo
        for (let i = 0; i < this.atlasInfo.logs.length; i++) {

          let at = {
            content: '',
            timestamp: ''
          }

          at.content = this.atlasInfo.logs[i].createUserInfo.name + '  ' + this.atlasInfo.logs[i].message
          at.timestamp = formatConversion(this.atlasInfo.logs[i].createAt.toString())

          this.activities.push(at)
        }
        // this.activities = []
        this.activities = this.activities.reverse()
        // console.log(this.atlasInfo)
      }
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    },

    //获取图集中的视频列表
    async listAtlasVideosAsync(val) {
      let { status, data, message, pagination } = await listAtlasVideos(val);
      if (status) {
        this.picList = data
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].type = 'video'
          if(this.picList[i].fileInfo.encodeSavepath){
            this.picList[i].src = picPrefix + this.picList[i].fileInfo.encodeSavepath
          }else{
            this.picList[i].src = picPrefix + this.picList[i].fileInfo.savepath
          }
          
          this.picList[i].savepath = picPrefix + this.picList[i].fileInfo.savepath
          
          
          if (this.picList[i].exif) {
            if(this.picList[i].exif.exif){
              let exif = JSON.parse(this.picList[i].exif.exif)
              if(exif.hasOwnProperty('video_cover')){
                this.picList[i].picThumbWh160 = picPrefix + exif.video_cover
              }else{
                this.picList[i].exif.videoCaptureFileIds = this.picList[i].exif.videoCaptureFileIds.split(',')
                if(this.picList[i].exif.videoCaptureFileIds.length > 1){
                  let picInfo = await getFileInfoById(this.picList[i].exif.videoCaptureFileIds[0])
                  if (picInfo.data) {
                    if (picInfo.data.picThumbWh160) {
                      this.picList[i].picThumbWh160 = picPrefix + picInfo.data.picThumbWh160
                    } else {
                      this.picList[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                    }
                  } else {
                    this.picList[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                  }
                }else{
                  this.picList[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                }
                
              }
            }
          } else {
            this.picList[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
          }
          

        }

        // this.chooseType(2)

        this.listAtlasPicturesAsync({
          atlasId: this.$route.query.id,
          page: this.page,
          pageSize: this.pageSize
        })
      }
    },
    //获取图集中的图片列表
    async listAtlasPicturesAsync(val,flag) {
      this.showLoading = false
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let { status, data, message, pagination } = await advSearchPicture(val);
      if (status) {
        
        // if (this.page === 0) {
        //   this.picList = data

        // } else {
          
        // }
        this.total = pagination.total;
        this.totalPage = pagination.totalPage;


        // for (let i = 0; i < data.length; i++) {

        //   if (data[i].exif && this.isJSON(data[i].exif)) {
        //     data[i].exif = JSON.parse(data[i].exif)
        //   }

        //   data[i].createName = data[i].createUserInfo.name;
        //   data[i].ext = data[i].fileInfo.ext;
        //   if (!data[i].customLabels) {
        //     if(data[i].labels.length == 0){
        //       data[i].customArr = "——";
        //     }else{
        //       data[i].customArr = data[i].labels
        //     }
        //   } else {
        //     let cuArr = data[i].customLabels.split(',')
        //     data[i].customArr = cuArr.concat(data[i].labels);
        //   }
        //   data[i].fileSize =
        //     (data[i].fileInfo.fileSize / 1024 / 1024).toFixed(2) + "MB";
        //   data[i].size = data[i].fileInfo.picW + " X " + data[i].fileInfo.picH;
        //   if(data[i].exif){
        //     if(data[i].exif.hasOwnProperty('CreateAt')){
        //       data[i].createAtp = formatConversion(data[i].exif.CreateAt.toString());
        //     }else{
        //       data[i].createAtp = "——";
        //     }
        //   }else{
        //     data[i].createAtp = "——";
        //   }
          
        //   data[i].createAtUp = formatConversion(data[i].fileInfo.createAt.toString());
          
        //   data[i].faceInfo = ''
        //   data[i].type = 'pic'
        //   if (data[i].fileInfo) {
        //     if (!data[i].fileInfo.picThumbH160) {
        //       data[i].src = require('@/assets/house/onloadpicin.png')
        //       data[i].picThumbWh160 = require('@/assets/house/onloadpicin.png')
        //       // data[i].srcW1080 = require('@/assets/house/onloadpicin.png')

        //       // data[i].src = picPrefix + data[i].fileInfo.savepath
        //       // data[i].picThumbWh160 = picPrefix + data[i].fileInfo.savepath
        //       data[i].srcW1080 = picPrefix + data[i].fileInfo.savepath
        //     } else {
        //       data[i].src = picPrefix + data[i].fileInfo.picThumbH160
        //       data[i].picThumbWh160 = picPrefix + data[i].fileInfo.picThumbWh160
        //       data[i].srcW1080 = picPrefix + data[i].fileInfo.picThumbW1080
        //     }

        //     //图片加载失败
        //     if (data[i].fileInfo.picThumbH160 === 'error') {
        //       data[i].errortext = 'error'
        //       data[i].src = require('@/assets/house/onloadpicerror.png')
        //       data[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
        //       data[i].srcW1080 = picPrefix + data[i].fileInfo.savepath
        //     }
        //     data[i].errortext = '123'

        //     let imgTest = new Image()
        //     imgTest.src = data[i].src
        //     imgTest.onerror = () => {
        //       data[i].errortext = 'error'
        //       data[i].src = require('@/assets/house/onloadpicerror.png')
        //       data[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
        //       data[i].srcW1080 = picPrefix + data[i].fileInfo.savepath
        //     }
        //   } else {
        //     data[i].src = require('@/assets/house/onloadpic.png')
        //     data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
        //     data[i].srcW1080 = require('@/assets/house/onloadpic.png')
        //   }


          


        // }

        for (let i = 0; i < data.length; i++) {

            
            data[i].exif = data[i].fileExif
            data[i].id = data[i].resourceId
            data[i].logs = []

            if(data[i].tags){
              data[i].labels = data[i].tags.split(",")
            }else{
              data[i].labels = []
            }

            data[i].createName = data[i].resourceCreateUserName;
            // data[i].ext = data[i].fileInfo.ext;
            if (!data[i].customLabels) {
              if(data[i].labels.length == 0){
                data[i].customArr = "——";
              }else{
                data[i].customArr = data[i].labels
              }
            } else {
              let cuArr = data[i].customLabels.split(',')
              data[i].customArr = data[i].labels.concat(cuArr);
            }
            data[i].fileSize =
              (data[i].fileSize / 1024 / 1024).toFixed(2) + "MB";
            data[i].size = data[i].picW + " X " + data[i].picH;
            if(data[i].exif){
              if(data[i].exif.hasOwnProperty('CreateAt')){
                data[i].createAtp = formatConversion(data[i].exif.CreateAt.toString());
              }else{
                data[i].createAtp = "——";
              }
            }else{
              data[i].createAtp = "——";
            }
            
            data[i].createAtUp = formatConversion(data[i].createAt.toString());
            
            data[i].type = "pic";




            if (data[i].picThumbH160) {
              data[i].src = picPrefix + data[i].picThumbH160;
              data[i].picThumbWh160 =
                picPrefix + data[i].picThumbWh160;
              data[i].srcW1080 =
                picPrefix + data[i].picThumbW1080;
            } else {
              data[i].src = require("@/assets/house/onloadpicin.png");
              data[i].picThumbWh160 = require("@/assets/house/onloadpicin.png");
              data[i].srcW1080 = picPrefix + data[i].savepath;
            }

            //图片加载失败
            if (data[i].picThumbH160 === "error") {
              data[i].errortext = "error";
              data[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              data[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              data[i].srcW1080 = picPrefix + data[i].savepath;
            }
            let imgTest = new Image();
            imgTest.src = data[i].src;
            imgTest.onerror = () => {
              data[i].errortext = "error";
              data[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              data[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              data[i].srcW1080 = picPrefix + data[i].savepath;
            };
          }

        

        

        for (let i = 0; i < data.length; i++) {
          this.picList.push(data[i]);
        }

        if (picLoveArray) {
          for (let i = 0; i < picLoveArray.length; i++) {
            for (let j = 0; j < this.picList.length; j++) {
              // console.log(picLoveArray[i].id)
              if (picLoveArray[i].id === this.picList[j].id) {
                this.picList[j].isLove = true
                this.loveList.push(this.picList[j].id)
                continue;
              }
            }
          }
        }

        if(flag){

          this.choosedata = JSON.parse(JSON.stringify(this.picList))
  
          if (this.picList.length < 1) {
            this.picFlag = false
          }
        }

        // this.choosedata =  JSON.parse(JSON.stringify( this.picList ))
        
        if(!flag){
          this.selectListAsync({
            pageNum: this.pageWord,
            pageSize: this.pageSizeWord,
            order:0,
            orderBy:'create',
            atlasId:this.$route.query.id
          })
        }

        this.picTableData = this.picList.filter((e) => e.type == "pic");
        // if (this.picList.length < 1) {
        //   this.picFlag = false
        // }
        // console.log(data)

      } else {
          let errortext = "";
          for (const key in errors) {
            errortext += errors[key];
          }
          this.$message.error({ message: message + errortext });
        }
      
    },


    openWord(e){
      if(e.path){
          if(e.path.indexOf('docx') ==-1){
             this.$message.error('暂不支持doc格式预览');
             return
        }
        if (e.path.indexOf("http") == -1) {
          this.picviewlist=this.picPrefix +  e.path
        }else{
         this.picviewlist=e.path
        }
        console.log( this.picviewlist);
        this.$refs.picviewA.src= this.picviewlist
        this.$refs.picviewA.previewShow=  true
        this.$refs.picviewA.loadFromUrl()
      }else{
        this.selectInfoAsync({id:e.id})
      }
    },
    

    //检索单个文稿
    async selectInfoAsync(val) {
      let { status, data, message, errors } = await selectInfo(
        val
      );
      if(status){
        this.wordContent = data.content
        this.wordDialog = true
      }
    },


    //检索文稿
    async selectListAsync(val) {
      let { status, data, message, pagination, errors } = await selectList(
        val
      );
      this.showLoading = false
      if(status){
        for (let i = 0; i < data.length; i++) {
          data[i].type = 'word'
          data[i].isUpload = false
          if(data[i].path){
            data[i].isUpload = true
          }

          data[i].picSrc = ''
          if(data[i].pictureList.length > 0){
            data[i].picSrc = this.picPrefix + data[i].pictureList[0].levelPath
          }

          data[i].mycreateAt = formatConversion(
            data[i].createAt.toString()
          );

          data[i].content = data[i].content.trim()
          var reg = new RegExp("/n","");
          data[i].content = data[i].content.replace(reg,"");
          
        }

        for (let i = 0; i < data.length; i++) {
          this.picList.push(data[i])
        }

        this.choosedata = JSON.parse(JSON.stringify(this.picList))

        if (this.picList.length < 1) {
          this.picFlag = false
        }
      }
    },
  },
  created() {


    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
        this.$store.commit('SET_BigImage', false);
        // console.log(1234);
      }
    }
    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth

    if (this.displayResolution > 2200) {
      this.pageSize = 50
    }
    if (this.displayResolution > 2600) {
      this.pageSize = 75
    }
    if (this.displayResolution > 3000) {
      this.pageSize = 105
    }

    this.getUserSettingAsync(this.createUid, 'picLove')
    this.getAtlasInfoAsync(this.$route.query.id)

    // setTimeout(() => {
    for (let i = 0; i < this.atlasInfo.pictureCount; i++) {
      let nopic = {
        src: require("@/assets/house/grey.png")
      }
      this.picList.push(nopic)
    }
    setTimeout(() => {
      this.listAtlasVideosAsync({
        id: this.$route.query.id,
        page: 0,
        pageSize: 50
      })
    }, 100);
    // }, 333);


  },
  mounted() {

    let self = this;
    this.$nextTick(function() {
      document.addEventListener('keyup', function(e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.setIsUpload(true)
        }
      })
    })

    window.addEventListener('scroll', this.handleScroll, true);

  },
  destroyed() { //离开这个界面之后，删除，不然会有问题
    window.removeEventListener('scroll', this.handleScroll)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./picbrowse.scss";
@import "@/constants/elHeader.scss";
/deep/ .el-select__caret:before {
  content: "\e78f";
  font-size: 16px;
  color: black;
}

.elinput /deep/ .el-input__inner {
  height: 45px;
  line-height: 45px;
}
.seepic /deep/ .el-dialog__header {
  display: none;
}
.seepic /deep/ .el-dialog__body {
  display: flex;
  padding: 0;
}

.bj {
  display: flex;
  align-items: center;
}

//改变图片放大的关闭的位置
/deep/ .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}
/deep/ .el-icon-circle-close {
  margin-top: 100px;
  color: white;
}

/deep/ .image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
